import css from './AxiosLoader.module.scss'

const AxiosLoader = () => <div className={css.LoaderBkg}></div>

export default AxiosLoader
